import _ from 'lodash'

// Using this simple pattern, we only put fields that require any sort of transformation under a namespaced key, we can
// be sure that the transformation back to the API should only ever involve mapping computed keys back.
//
// Making it very clear which values are computed at this point. Also makes it easier for the API translation, since
// we can be sure we should only ever be translating values from this single computed object, instead of backtracking
// to find out which keys are translated keys.
const transformerFactory = ({
  uiToApi = _.identity,
  apiToUi = _.identity,
} = {}) => ({
  apiToUi: obj => {
    obj = _.cloneDeep(obj)

    const computed = Object.create(null)

    obj.__computed__ = computed

    apiToUi(obj)

    return obj
  },

  uiToApi: obj => {
    obj = _.cloneDeep(obj)

    uiToApi(obj)

    // [A transformation Haiku]
    //
    // Your purpose is done
    // my sweet prince; you may now rest.
    // Your freedom starts now.
    delete obj.__computed__

    return obj
  },
})

export default transformerFactory
